export class FilterItemSummaryRow {
  constructor(public label: string, public icon?: string, public key?: string) {}
}
